module.exports = __webpack_public_path__ + "static/venom_troll-f383c33c22f10f3b61dccc307154e045.png";